import axiosInstance from '@/lib/axios';
import { handleApiError } from '@/lib/api-error-handler';

export interface WhiteLabelSettings {
  companyName: string | null;
  headerTitle: string | null;
  logoUrl: string | null;
  logoSmallUrl: string | null;
  primaryColor: string | null;
  secondaryColor: string | null;
  accentColor: string | null;
}

export interface UpdateWhiteLabelRequest {
  companyName?: string | null;
  headerTitle?: string | null;
  logoUrl?: string | null;
  logoSmallUrl?: string | null;
  primaryColor?: string | null;
  secondaryColor?: string | null;
  accentColor?: string | null;
}

class WhiteLabelApi {
  /**
   * Obter configurações de white-label da conta (autenticado)
   */
  async getSettings(): Promise<WhiteLabelSettings> {
    try {
      const response = await axiosInstance.get<WhiteLabelSettings>('/v1/accounts/me/white-label');
      return response.data;
    } catch (error: any) {
      throw handleApiError(error);
    }
  }

  /**
   * Obter configurações de white-label públicas (sem autenticação - para login/registro)
   */
  async getPublicSettings(): Promise<WhiteLabelSettings> {
    try {
      const response = await axiosInstance.get<WhiteLabelSettings>('/public/white-label');
      return response.data;
    } catch (error: any) {
      throw handleApiError(error);
    }
  }

  /**
   * Atualizar configurações de white-label da conta
   */
  async updateSettings(data: UpdateWhiteLabelRequest): Promise<WhiteLabelSettings> {
    try {
      const response = await axiosInstance.put<WhiteLabelSettings>('/v1/accounts/me/white-label', data);
      return response.data;
    } catch (error: any) {
      throw handleApiError(error);
    }
  }
}

export const whiteLabelApi = new WhiteLabelApi();
